import { AxiosError } from 'axios';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { useAuthorizationContext } from 'src/components/authorization';

import axios from './axios';

export interface UseCloseAllSessionsVariables {}

export interface UseCloseAllSessionsData {}

export function useCloseAllSessions() {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const { logout } = useAuthorizationContext();

  return useMutation<
    UseCloseAllSessionsData,
    AxiosError<never>,
    UseCloseAllSessionsVariables
  >(
    (variables) => {
      return axios
        .delete<UseCloseAllSessionsData>(`/posht/ashena/signout/token/all/`)
        .then((res) => res.data);
    },
    {
      onError: () => {
        enqueueSnackbar(t('errors.unknown'), { variant: 'error' });
      },
      onSuccess: () => {
        logout();
      },
    },
  );
}
